/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_CompanyInputs */

const en_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const de_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const fr_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const es_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const it_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const nl_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const pl_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const fi_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const da_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

const sv_jobs_placeholder_company = /** @type {(inputs: Jobs_Placeholder_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acme Corp`)
};

/**
* | output |
* | --- |
* | "Acme Corp" |
*
* @param {Jobs_Placeholder_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_company = /** @type {((inputs?: Jobs_Placeholder_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_company(inputs)
	if (locale === "fr") return fr_jobs_placeholder_company(inputs)
	if (locale === "es") return es_jobs_placeholder_company(inputs)
	if (locale === "it") return it_jobs_placeholder_company(inputs)
	if (locale === "nl") return nl_jobs_placeholder_company(inputs)
	if (locale === "pl") return pl_jobs_placeholder_company(inputs)
	if (locale === "fi") return fi_jobs_placeholder_company(inputs)
	if (locale === "da") return da_jobs_placeholder_company(inputs)
	if (locale === "sv") return sv_jobs_placeholder_company(inputs)
	return en_jobs_placeholder_company(inputs)
});